import { defaultProductionPagination } from '../../constants/consts';

export const GET_PROFILE_DATA = 'app/ArtistPage/GET_PROFILE_DATA';
export const SET_PROFILE = 'app/ArtistPage/SET_PROFILE';
export const GET_PROFILE_PRODUCTIONS = 'app/ArtistPage/GET_PROFILE_PRODUCTIONS';
export const GET_PROFILE_REPERTOIRE = 'app/ArtistPage/GET_PROFILE_REPERTOIRE';
export const GET_PROFILE_IMAGES = 'app/ArtistPage/GET_PROFILE_IMAGES';
export const GET_PROFILE_BANNER_IMAGES = 'app/ArtistPage/GET_PROFILE_BANNER_IMAGES';
export const GET_PROFILE_MEDIA_ATTRIBUTE_TYPES = 'app/ArtistPage/GET_PROFILE_MEDIA_ATTRIBUTE_TYPES';
export const GET_PROFILE_BIO = 'app/ArtistPage/GET_PROFILE_BIO';
export const GET_PROFILE_REVIEWS = 'app/ArtistPage/GET_PROFILE_REVIEWS';
export const SET_PROFILE_ACTIVE_VIDEO = 'app/ArtistPage/SET_PROFILE_ACTIVE_VIDEO';
export const GET_PROFILE_PRODUCTIONS_SEASONS = 'app/ArtistPage/GET_PROFILE_PRODUCTIONS_SEASONS';
export const GET_PROFILE_WORKS_LIST = 'app/ArtistPage/GET_PROFILE_WORKS_LIST';
export const CLEAR_PROFILE_WORKS_LIST = 'app/ArtistPage/CLEAR_PROFILE_WORKS_LIST';
export const START_SEARCHING_PROFILE_WORKS_LIST = 'app/ArtistPage/START_SEARCHING_PROFILE_WORKS_LIST';
export const GET_PROFILE_AGREEMENTS = 'app/ArtistPage/GET_PROFILE_AGREEMENTS';
export const GET_SEARCH_PRODUCTIONS_LIST = 'app/ArtistPage/GET_SEARCH_PRODUCTIONS_LIST';
export const GET_ARTIST_PROFESSIONS = 'app/ArtistPage/GET_ARTIST_PROFESSIONS';
export const GET_ARTIST_ROLES = 'app/ArtistPage/GET_ARTIST_ROLES';
export const GET_PRODUCTION_CAST = 'app/ArtistPage/GET_PRODUCTION_CAST';
export const GET_WISHLIST_REPERTOIRE = 'app/ArtistPage/GET_WISHLIST_REPERTOIRE';
export const UPDATE_REPERTOIRE_STATUS = 'app/ArtistPage/UPDATE_REPERTOIRE_STATUS';
export const UPDATE_REPERTOIRE_MODAL = 'app/ArtistPage/UPDATE_REPERTOIRE_MODAL';

export const UPDATE_PROFILE = 'app/ArtistPage/UPDATE_PROFILE';
export const GET_VIDEO = 'app/ArtistPage/GET_VIDEO';
export const ADD_VIDEO = 'app/ArtistPage/ADD_VIDEO';
export const UPDATE_VIDEO = 'app/ArtistPage/UPDATE_VIDEO';

export const UPDATE_BIO = 'app/ArtistPage/UPDATE_BIO';
export const ADD_BIO = 'app/ArtistPage/ADD_BIO';
export const GET_CONTACTS = 'app/ArtistPage/GET_CONTACTS';
export const UPDATE_CONTACTS = 'app/ArtistPage/UPDATE_CONTACTS';
export const ADD_REVIEW = 'app/ArtistPage/ADD_REVIEW';
export const UPDATE_REVIEW = 'app/ArtistPage/UPDATE_REVIEW';
export const REMOVE_PRODUCTION = 'app/ArtistPage/UPDATE_PRODUCTION_PRIVACY';
export const DELETE_PRODUCTION = 'app/ArtistPage/DELETE_PRODUCTION';
export const PUBLISH_PRODUCTION = 'app/ArtistPage/PUBLISH_PRODUCTION';
export const GET_DATES_IN_PRODUCTIONS = 'app/ArtistPage/GET_DATES_IN_PRODUCTIONS';
export const GET_ARTIST_PRODUCTIONS_PRIVACY = 'app/ArtistPage/GET_ARTIST_PRODUCTIONS_PRIVACY';
export const ADD_UPDATE_CONTACTS = 'app/ArtistPage/ADD_UPDATE_CONTACTS';
export const GET_PROFILE_REPERTOIRE_PRODUCTION = 'app/ArtistPage/GET_PROFILE_REPERTOIRE_PRODUCTION';
export const GET_PROFILE_REPERTOIRE_IMAGES = 'app/ArtistPage/GET_PROFILE_REPERTOIRE_IMAGES';
export const GET_PROFILE_REPERTOIRE_VIDEOS = 'app/ArtistPage/GET_PROFILE_REPERTOIRE_VIDEOS';
export const DELETE_BIO = 'app/ArtistPage/DELETE_BIO';
export const UPDATE_ARTIST_BANNER = 'app/ArtistPage/UPDATE_ARTIST_BANNER';
export const DELETE_IMAGE = 'app/ArtistPage/DELETE_IMAGE';
export const DELETE_VIDEO = 'app/ArtistPage/DELETE_VIDEO';
export const DELETE_REVIEW = 'app/ArtistPage/DELETE_REVIEW';
export const GET_ARTIST_PRODUCTIONS_COUNT = 'app/ArtistPage/GET_ARTIST_PRODUCTIONS_COUNT';
export const CLEAN_SEARCH_PRODUCTIONS_LIST = 'app/ArtistPage/CLEAN_SEARCH_PRODUCTIONS_LIST';
export const REMOVE_REPERTOIRE_RECORD = 'app/ArtistPage/REMOVE_REPERTOIRE_RECORD';
export const SET_PROFILE_PERFORMANCES = 'app/ArtistPage/SET_PROFILE_PERFORMANCES';
export const GET_ARTIST_PRODUCTIONS = 'app/ArtistPage/GET_ARTIST_PRODUCTIONS';
export const GET_VIDEO_FORMAT_TYPES = 'app/ArtistPage/GET_VIDEO_FORMAT_TYPES';
export const UPDATE_REPERTOIRE = 'app/ArtistPage/UPDATE_REPERTOIRE';

export const defaultArtistProductionsPagination = defaultProductionPagination;
